<template>
    <div class="idea-card container">
        <div class="row">
            <div class="reviews">
                <div class="container idea-page">
                    <div class="row">
                        <div class="col-12 col-lg-2 back-remove">
                            <button @click="$router.push({ name: 'ideas' })" class="button-back">
                                <span>Назад</span>
                            </button>
                        </div>

                        <div class="col-12 col-lg-10 mobile-rew">
                            <Idea v-if="idea" 
                                  :idea="idea"
                                  @deleted="$router.push({ name: 'ideas' })" />
                        </div>

                    </div>
                </div>
            </div>


            <div  v-if="idea.status_id > 1 || isAdmin || idea.user_id === user.id" style="width: 100%;">
                <div class="reviews-messages col-md-10 col-md-offset-2">

                    <h3 v-if="idea.comments > 0">Комментарии:  &nbsp;&nbsp; {{idea.comments}}</h3>
                    <h3 v-if="idea.comments == 0">Пока что нет комментариев.</h3>

                    <Comment v-for="comment in idea.rootComments"
                             :key="comment.id"
                             :comment="comment" />
                </div>

                <div class="reviews-form-block">
                    <div class="reviews-form col-md-10 col-md-offset-2">
                        <div v-if="!isLogged">
                            <em>Необходимо <router-link :to="{name: 'login'}" class="link">авторизоваться</router-link>, чтобы оставить комментарий.</em>
                        </div>
                        <div v-if="isLogged">
                            <Editor placeholder="Оставьте комментарий"
                                    :content="newCommentHtml"
                                    @change="setNewComment"
                                    @ctrl-enter="!hasErrorComment(newCommentText) && saveComment()"/>
                            <div style="height: 1em; margin: 1em 0">
                                <p v-show="hasSmallComment(newCommentText)">
                                    <em>Сообщение должно быть как минимум 20 символов.</em>
                                </p>
                                <p v-show="hasNormalComment(newCommentText)">
                                    <em>Длина сообщения {{ newCommentText.length }} из 4096 символов.</em>
                                </p>
                                <p class="error" v-show="hasLargeComment(newCommentText)">
                                    <em>Слишком длинное сообщение. {{ newCommentText.length }} из 4096 символов.</em>
                                </p>
                            </div>
                            <button :disabled="hasErrorComment(newCommentText)"
                                    class="reviews-button"
                                    @click="saveComment">Отправить</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import IdeaComponent from './Idea';
    import IdeaCommentComponent from './Comment';
    import Editor from './Editor';

    export default {
        name: 'IdeaPage',
        components: {
            'Idea': IdeaComponent,
            'Comment': IdeaCommentComponent,
            'Editor': Editor 
        },

        data() {
            return {
                parentCommentId: null,
                newCommentHtml: '',
                newCommentText: ''
            }
        },

        computed: {
            idea() {
                return this.$store.state.ideas.idea;
            },

            user() {
                return this.$store.state.auth.user;
            },

            isAdmin() {
                return this.$store.getters['auth/isAdmin'];
            },

            isLogged() {
                return this.$store.getters['auth/isLogged'];
            }
        },

        mounted () {
            this.$store.dispatch('ideas/setCurrentIdeaId', this.$route.params.id)
        },

        beforeRouteUpdate (to, from, next) {
            this.$store.dispatch('ideas/setCurrentIdeaId', to.params.id)
            next()
        },

        methods: {

            setNewComment ({ html, text }) {
                this.newCommentHtml = html
                this.newCommentText = text
            },

            hasErrorComment (comment) {
                return this.hasSmallComment(comment) || this.hasLargeComment(comment)
            },

            hasSmallComment (comment) {
                return comment.length < 20
            },

            hasNormalComment (comment) {
                return comment.length >= 20 && comment.length <= 4096
            },

            hasLargeComment (comment) {
                return comment.length > 4096
            },

            saveComment () {
                this.$store.dispatch('ideas/saveComment', {
                    ideaId: this.idea.id,
                    parentId: null,
                    text: this.newCommentHtml
                }).then((data) => {
                    this.newCommentHtml = ''
                    this.$store.dispatch('ideas/loadIdea')
                })
            }
        }
    }

</script>

<style>
    .remove-button {
        float: right;
        display: block;
    }
    .message:hover .remove-button {
        display: block;
    }
</style>


// WEBPACK FOOTER //
// IdeaPage.vue?6380bd0a